// extracted by mini-css-extract-plugin
module.exports = {"button":"SignIn_button__39iVL","errorMsg":"SignIn_errorMsg__2UG-y"};